import ACTION_TYPES from '../../constants/actionTypes';
import omit from 'lodash/omit';
const reducers = {
  airlinesFetchedAt(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_AIRLINES_SUCCESS:
        return Date.now();
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  airlines(state = [], action) {
    switch (action.type) {
      case ACTION_TYPES.GET_AIRLINES_SUCCESS:
        return action.airlines;
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  countries(state = [], action) {
    switch (action.type) {
      case ACTION_TYPES.GET_L10N_SUCCESS:
        return action.payload.countries;
      default:
        return state;
    }
  },

  isAddPaymentMethodInProgress(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.ADD_PAYMENT_METHOD_REQUEST:
        return true;
      case ACTION_TYPES.ADD_PAYMENT_METHOD_SUCCESS:
      case ACTION_TYPES.ADD_PAYMENT_METHOD_FAILURE:
        return false;
      default:
        return state;
    }
  },

  isPurchaseInProgress(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.PURCHASE_BAGGAGE:
      case ACTION_TYPES.PURCHASE_BOP:
        return true;
      case ACTION_TYPES.PURCHASE_BAGGAGE_SUCCESS:
      case ACTION_TYPES.PURCHASE_BAGGAGE_FAILURE:
      case ACTION_TYPES.PURCHASE_BOP_SUCCESS:
      case ACTION_TYPES.PURCHASE_BOP_FAILURE:
      case ACTION_TYPES.SIGN_OUT:
        return false;
      default:
        return state;
    }
  },

  toast(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.SHOW_TOAST:
        return {
          message: action.message,
          style: action.style,
        };
      case ACTION_TYPES.HIDE_TOAST:
        return null;
      default:
        return state;
    }
  },

  isMenuOpen(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.SHOW_MENU:
        return true;
      case ACTION_TYPES.HIDE_MENU:
        return false;
      default:
        return state;
    }
  },

  activeGlobalModal(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.SHOW_GLOBAL_MODAL:
        return action.payload.id;
      case ACTION_TYPES.HIDE_GLOBAL_MODAL:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  globalModalProps(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.SHOW_GLOBAL_MODAL:
        return omit(action.payload, 'id') || {};
      case ACTION_TYPES.HIDE_GLOBAL_MODAL:
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  isEmbed(state = false, action) {
    return state;
  },

  metadata(state = {}, action) {
    return state;
  },

  settings(state = {}, action) {
    return state;
  },
};

export default reducers;
